export default __webpack_public_path__ + "static/media/filter-icon.7415abb3.svg";